import { render, staticRenderFns } from "./FavoriteResources.vue?vue&type=template&id=cc38894a&"
import script from "./FavoriteResources.vue?vue&type=script&lang=js&"
export * from "./FavoriteResources.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteResources.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports